export default __webpack_public_path__ + "static/coll-mens-health-7612442120cd4f88d2774f9b93d1a2f4.jpg";